<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataCustomers")
    template(v-if="$route.name === 'DataCustomerNew'")
      b-icon(icon="user")
      h1.title Neuer Gast
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'DataCustomerEdit' && formData.id")
      h1.title Gast \#{{formData.id}}
      .sub-headline Zuletzt bearbeitet am {{formatDate(formData.updatedAt)}} Uhr
      .status-wrapper
        b-taglist(attached)
          b-tag(type="is-light") Potentieller Gesamtumsatz
          b-tag(type="is-success") {{totalRevenue() / 100 | toCurrency}}
  
    .guest-wrapper.margin-top
      .two-column
        .column
          .card
            .top
              .left
                .card-headline Gastdaten
                .card-description Hier finden Sie den kompletten Datensatz des Gast.
              .right
            .main.padding
              ValidationObserver(v-slot="{ handleSubmit }")
                .form
                  h2.title.is-6 Allgemein
                  ValidationProvider(name="Anrede" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Anrede" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-select(v-model="formData.salutation")
                        option(value="Frau") Frau
                        option(value="Herr") Herr
                  ValidationProvider(name="Vorname" :rules="$route.query.showContract ? 'required' : ''" v-slot="{ errors, valid }") 
                    b-field(label="Vorname" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.firstName")
                  
                  ValidationProvider(name="Nachname" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Nachname" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.lastName")

                .form.margin-top
                  h2.title.is-6 Adresse
                  //- b-field(label="Zeile 1" label-position="on-border")
                    b-input(v-model="formData.address.line1")
                  
                  ValidationProvider(name="Straße und HausNr." :rules="$route.query.showContract ? 'required' : ''" v-slot="{ errors, valid }") 
                    b-field(label="Straße und HausNr." label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.street")
                  
                  b-field(grouped)
                    ValidationProvider(name="PLZ" :rules="$route.query.showContract ? 'required' : ''" v-slot="{ errors, valid }") 
                      b-field(label="PLZ" label-position="on-border"
                              :type="{ 'is-danger': errors[0] }" :message="errors")
                        b-input(v-model="formData.address.zip")
                    .spacer.sm
                    ValidationProvider(name="Stadt" :rules="$route.query.showContract ? 'required' : ''" v-slot="{ errors, valid }") 
                      b-field(label="Stadt" label-position="on-border"
                              :type="{ 'is-danger': errors[0] }" :message="errors")
                        b-input(v-model="formData.address.city")

                  ValidationProvider(name="Land" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Land" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.country")

                  b-field(label="Geburtstag" label-position="on-border")
                    v-date-picker(:columns="2" v-model="formData.birthday")
                      template(v-slot='{ inputValue, inputEvents }')
                        input.input(:value='inputValue' v-on='inputEvents')

                .form.margin-top
                  h2.title.is-6 Kontakt
                  ValidationProvider(name="E-Mail" rules="email" v-slot="{ errors, valid }") 
                    b-field(label="E-Mail" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.email")
                  ValidationProvider(name="Alternative E-Mail" rules="email" v-slot="{ errors, valid }") 
                    b-field(label="Alternative E-Mail" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.email2")
                  ValidationProvider(name="Mobiltelefon" rules="" v-slot="{ errors, valid }") 
                    b-field(label="Mobiltelefon" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.mobile")
                  ValidationProvider(name="Telefon" rules="" v-slot="{ errors, valid }") 
                    b-field(label="Telefon" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.phone")

                .form.margin-top
                  b-field(label="Kommentar zum Gast" label-position="on-border")
                    b-input(type="textarea" v-model="formData.comment")
                  b-field
                    b-switch(type="is-success" v-model="formData.gdprOptIn") DSGVO Einverständnis
                  b-field
                    b-switch(type="is-danger" v-model="formData.isBlacklist") Blacklist Gast

                .button-wrapper.margin-top.right
                  b-button(type="is-light" @click="$router.push({name: 'DataCustomers'})") Abbrechen
                  b-button(type="is-primary" @click="handleSubmit(updateCustomer)") Speichern
          
        .column
          .card
            .top
              .left
                .card-headline Aktivität
                .card-description Hier finden Sie alle Angebote & Buchungen des Gast.
              .right
            .main.padding
              b-table(:data="formData.rentObjectBookings"
                default-sort-direction="asc"
                default-sort="date"
                hoverable
                @click="row => $router.push('/booking/'+row.id)")
                b-table-column(field='name' label='Status' sortable centered numeric v-slot="props")
                  .r-name {{ props.row.bookingStatus.name }}
                b-table-column(field='name' label='Mietobjekt' sortable centered numeric v-slot="props")
                  .r-name {{ props.row.rentObject.name }}
                b-table-column(field='createdAt' label='Von' sortable centered v-slot="props")
                  | {{ simpleDate(props.row.startDate) }}
                b-table-column(field='createdAt' label='Bis' sortable centered v-slot="props")
                  | {{ simpleDate(props.row.endDate) }}
                b-table-column(label='Betrag' sortable v-slot="props")
                  span.tag.is-success
                    |{{sumBookingItems(props.row.bookingItems) / 100 | toCurrency}}

</template>

<script>
import {DateTime} from "luxon"

export default {
  components: {
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      customer: null,
      formData: {
        salutation: null,
        firstName: null,
        lastName: null,
        birthday: null,
        comment: "",
        gdprOptIn: false,
        isBlacklist: false,
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          phone: null,
          mobile: null,
          fax: null
        }
      }
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();

    if (this.$route.name !== "DataCustomerNew" && this.id) {
      this.customer = await this.$store.dispatch("customers/findOne", { id: this.id });
      this.customer.birthday = DateTime.fromISO(this.customer.birthday).toJSDate();
      this.formData = {
        ...this.formData,
        ...JSON.parse(JSON.stringify(this.customer))
      };
    }
    loadingComponent.close();
  },
  methods: {
    async updateCustomer() {
      if (this.id) {
        this.formData.birthday = DateTime.fromJSDate(this.formData.birthday).toISODate();
        await this.$store.dispatch("customers/update", this.formData);
        
        // When we come from a different view to this view, we send the customer back
        if(this.$route.query.from) {
          let route = this.$route.query.from+'?fromCustomer='+this.customer.id;
          route += this.$route.query.showContract ? `&showContract=true` : '';
          this.$router.push(route);
        }
      } else {
        this.formData.birthday = DateTime.fromJSDate(this.formData.birthday).toISODate();
        const newCustomer = await this.$store.dispatch("customers/create", this.formData);
        this.$router.push({ name: "DataCustomerEdit", params: { id: newCustomer.id } });
      }
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    simpleDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    sumBookingItems(items) {
      let total = 0;
      items.forEach(i => {
        total += i.totalPrice;
      });
      return total;
    },
    totalRevenue() {
      let total = 0;
      for (let i = 0; i < this.customer.rentObjectBookings.length; i += 1) {
        total += this.sumBookingItems(this.customer.rentObjectBookings[i].bookingItems)
      }
      return total;
    }
  }
}
</script>

<style lang="scss" scoped>
.status-wrapper {
  margin-top: $xs-space;
}

.button-wrapper {
  margin: $xs-space 0 $sm-space 0;
}
.two-column {
  display: flex;
  justify-content: space-between;
}
.r-name {
  font-weight: 500;
}
.label {
  font-weight: 600;
  margin-top: $sm-space;
  margin-bottom: 0;
  &:not(:last-child) {
    margin-bottom: 0;
  }
}
</style>